( function () {
	var _overlay = document.querySelectorAll( '.md-overlay' );
	
	// Hides active modal dialogs, then destroys any iframes they contain
	function close( a ) {
		
		var content = a.closest( '.md-content' ),
			iframe = content.querySelector( 'iframe' );
		
		document.querySelectorAll( '.md-modal' ).forEach( function( modal ) {
			modal.classList.remove( 'md-show' );
		} );
		
		document.body.classList.remove( 'modal-open' );
		
		if ( iframe ) {
			iframe.remove();
		}
	}
	
	// Get the list of IDs for video modal regions. The id "video-listing" is used for templates that have just one
	// set of video tiles. Content blocks can produce other video sets, and those should all have been registered
	// with their own unique IDs also.
	function divSelectors() {
		var sel = window.SYR.videoModalRegions.join( ',' );
		if( sel && sel.length ) { 
			return '#video-listing,' + sel;
		}
		
		return '#video-listing';
	}
	
	function init() {
		var div = document.querySelector( divSelectors() );
		if( !div ) { return; }
		
		// Modal trigger event handler: 
		// (1) Locate the appropriate modal
		// (2) Add the iframe with the YouTube reference
		// (3) Show the modal by adding class "md-show" to it
		div.addEventListener( 'click', function( e ) {
			if ( e.target.closest( 'a.md-trigger' ) ) {
				e.preventDefault();
				var vid = e.target.parentElement;
				
				var videoId = vid.dataset.video,
					modal = document.querySelector( '#modal-' + videoId ),
					div = modal.querySelector( 'div.before-iframe' ),
					url = div.dataset.yturl,
					title = modal.querySelector( 'h3' ).innerText;
				
				var iframe = document.createElement( 'iframe' );
				iframe.setAttribute( 'width', '100%' );
				iframe.setAttribute( 'height', '420' );
				iframe.setAttribute( 'src', url );
				iframe.setAttribute( 'title', title );
				iframe.setAttribute( 'frameborder', '0' );
				iframe.setAttribute( 'allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' );
				iframe.setAttribute( 'referrerpolicy', 'strict-origin-when-cross-origin' );
				iframe.setAttribute( 'allowfullscreen', '' );				
				
				
				div.appendChild( iframe );
				modal.classList.add( 'md-show' );
				document.body.classList.add( 'modal-open' );
			}
		} );
		
		// Clicking the close box dismisses the modal
		div.addEventListener( 'click', function( e ) {
			if ( e.target.matches( 'a.md-close' ) ) {
				e.preventDefault();
				close( e.target );
			} else if ( e.target.parentElement.matches( 'a.md-close' ) ) {
				e.preventDefault();
				close( e.target.parentElement );
			}
		} );

		// Clicking on the background overlay dismisses the modal
		_overlay.forEach( function( overlay ) {
			overlay.addEventListener( 'click', function ( e ) {
				var prev = this.previousElementSibling;
				e.preventDefault();

				while ( prev ) {
					if ( prev.matches( '.md-modal' ) ) {
						close( prev.querySelector( 'a.md-close' ) );
					}

					prev = prev.previousElementSibling;
				}
				
			} );
		} );
	}
	
	document.addEventListener( 'DOMContentLoaded', function () {
		init();
	} );
}() );